import { Col, Row, Form, Select } from "antd";
import { useState, Dispatch, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "./AddEditCustomer";
import InputName from "../UI/InputNumberComponent/InputName";

type props = {
  formatedCountries: Option[] | undefined;
  loadingCountries: boolean;
  setSelectedCountry: Dispatch<any>;
  selectedCountry: any
};

function AddressInformation({
  formatedCountries,
  loadingCountries,
  setSelectedCountry,
  selectedCountry
}: props) {
  const [t] = useTranslation("common");
  const [, setPostalCode] = useState("");

  const handlePostalCodeChange = (event: string) => {
    const formattedValue = event?.replace(/[^A-Za-z0-9-]/g, "");
    setPostalCode(formattedValue);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Item
            label={`${t("country")}`}
            name="countryId"
            initialValue={selectedCountry?.value}
          >
            <Select
              showSearch={true}
              optionFilterProp="label"
              onChange={(value: any) => setSelectedCountry(value)}
              placeholder={`${t("select-country")}`}
              options={formatedCountries}
              loading={loadingCountries}
            />
          </Form.Item>

          <Form.Item name="city" label={`${t("city")}`}>
            <InputName maxLength={50} data-testid="city-input" />
          </Form.Item>

          <Form.Item name="addressLine1" label={`${t("address")}`}>
            <InputName maxLength={50} data-testid="adderss-input" />
          </Form.Item>

          <Form.Item name="postalCode" label={`${t("postal-code")}`}>
            <InputName
              onChange={handlePostalCodeChange}
              maxLength={20}
              data-testid="postal-code"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default AddressInformation;
